import React from "react";
import Article from "./Article";
import Swiper from "@components/Swiper";
import Icons from "@gstyles/styleguide/icons";
import useSwiper from "@hooks/useSwiper";
import styles from "./SectionArticleMobile.module.scss";
import cx from "classnames";
import _ from "lodash";
import { usePageContext } from "@providers/PageProvider";
import { discoverPage } from "@utils/helper";
const formatPaginationNumber = (
  locales?: string,
  options?: Intl.NumberFormatOptions
) => {
  return (value: number) =>
    new Intl.NumberFormat(
      locales ?? "de-DE",
      options ?? { minimumIntegerDigits: 2 }
    ).format(value);
};
const View = ({ className }: any) => {
  const [activeIndex, $activeIndex] = React.useState(0);

  const { pageData } = usePageContext();
  const articles = discoverPage.formatArticles(pageData);
  useSwiper(`.article-swiper`, {
    speed: 1000,
    spaceBetween: 32,
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      1280: {
        slidesPerView: 2,
      },
      1500: {
        slidesPerView: 3,
      },
    },
    navigation: {
      nextEl: `.swiper-arrow-next-article`,
      prevEl: `.swiper-arrow-prev-article`,
    },
    on: {
      slideChange: (swiper) => {
        if (swiper) {
          $activeIndex(swiper.realIndex);
        }
      },
    },
  });
  const formatFractionNumber = formatPaginationNumber();
  return (
    <section
      data-scroll-section
      className={cx("inner-large", styles.section, className)}
    >
      <div className={cx(styles.fractionBox)}>
        <Icons
          name="arrow-left-outline"
          size={20}
          color="#000"
          className={cx(`swiper-arrow-prev-article`, styles.prevArrowIconMb)}
        />
        <div className={cx(styles.fraction)}>{`${formatFractionNumber(
          activeIndex + 1
        )} / ${formatFractionNumber(articles.length)}`}</div>
        <Icons
          name="arrow-right-outline"
          size={20}
          color="#000"
          className={cx(`swiper-arrow-next-article`, styles.prevArrowIconMb)}
        />
      </div>
      <Swiper className={cx(`article-swiper`, styles.swiper)}>
        {_.map(articles, (item: any, index: number) => {
          return (
            <Article
              articleClassName={styles.article}
              className={cx("swiper-slide")}
              border="none"
              type={cx({
                ["left"]: index % 2 !== 0,
                ["right"]: index % 2 === 0,
              })}
              {...item}
              key={`card_${index}`}
            />
          );
        })}
      </Swiper>
    </section>
  );
};
export default View;
